<template>
    <v-dialog
        v-model="dialog"
        persistent
        eager
        :max-width="displayWidth"
        @keydown.esc="onEscapeKeydown"
    >
        <v-card role="region" aria-label="tags-bulk-add-remove">
            <v-card-title class="py-2">
                <div>{{ title }}</div>
            </v-card-title>
            <v-card-text class="pt-3">
                <v-select
                    v-model="added"
                    label="Add tags"
                    multiple
                    small-chips
                    hide-selected
                    deletable-chips
                    item-text="name"
                    item-value="id"
                    class=""
                    :items="tagSource"
                ></v-select>
                <v-select
                    v-model="removed"
                    label="Remove tags"
                    multiple
                    small-chips
                    hide-selected
                    deletable-chips
                    item-text="name"
                    item-value="id"
                    class=""
                    :items="removeTagsSource"
                ></v-select>
            </v-card-text>
            <v-card-actions class="px-4 justify-end">
                <v-btn small text outlined @click="onCancelClick">{{
                    options.cancelActionText
                }}</v-btn>
                <v-btn small color="primary" @click="onConfirmClick">{{
                    options.confirmActionText
                }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ConfirmationPromiseDialog',
    data() {
        return {
            dialog: false,
            resolve: null,
            reject: null,
            title: '',
            tagType: 'space',
            options: {
                confirmActionText: 'Confirm',
                cancelActionText: 'Cancel',
                width: '450'
            },
            removeTagsFilter: [],
            added: [],
            removed: []
        };
    },
    computed: {
        ...mapState('tags', ['spaceTags', 'deviceTags']),
        tagSource() {
            if (this.tagType === 'space') {
                return this.spaceTags;
            } else {
                return this.deviceTags;
            }
        },
        removeTagsSource() {
            if (this.removeTagsFilter && this.removeTagsFilter.length) {
                return this.tagSource.filter(item =>
                    this.removeTagsFilter.includes(item.name)
                );
            }
            return this.tagSource;
        },
        displayWidth() {
            if (this.$vuetify.breakpoint.smAndDown) {
                return '90%';
            }
            return this.options.width;
        }
    },
    watch: {
        dialog() {
            this.added = [];
            this.removed = [];
        }
    },
    methods: {
        // ==================== Events ====================
        open(title, tagType, removeTagsFilter, options) {
            this.dialog = true;
            this.title = title;
            this.tagType = tagType;
            this.removeTagsFilter = removeTagsFilter || [];
            this.options = { ...this.options, ...options };
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        onCancelClick() {
            this.resolve(false);
            this.dialog = false;
        },
        onConfirmClick() {
            this.resolve({
                result: true,
                added: this.added,
                removed: this.removed
            });
            this.dialog = false;
        },
        onEscapeKeydown() {
            this.onCancelClick();
        }
        // =================== Others ======================
    }
};
</script>

<style lang="scss" scoped></style>
